import { useState } from 'react'
import ZIcon from '../components/ZIcon'
import { AppropriatenessAssessmentPassIcon } from '../assets/icons'
import ZButton from '../components/ZButton'
import ZText from '../components/ZText'
import ZBottomContainer from '../components/ZBottomContainer'
import ZScreenContainer from '../components/ZScreenContainer'
import CancelFlow from './CancelFlow'

const ConfirmationOfAcceptance = ({
  message,
  onDecision,
  loading,
}: {
  message: string
  onDecision: (accepted: boolean) => void
  loading: boolean
}) => {
  const [confirmingExit, setConfirmingExit] = useState<boolean>(false)

  if (confirmingExit) {
    return (
      <CancelFlow
        body="If you skip this step, this process will be cancelled and you will not be able to invest in cryptoassets."
        buttonText="Resume the process"
        cancelText="I wish to leave this investment journey"
        loading={loading}
        onDecision={proceed => {
          if (proceed) {
            setConfirmingExit(false)
          } else {
            onDecision(false)
          }
        }}
      />
    )
  }

  return (
    <ZScreenContainer>
      <ZIcon
        Icon={AppropriatenessAssessmentPassIcon}
        title="Confirmation of acceptance icon"
        style={{ alignSelf: 'center' }}
      />

      <ZText whiteSpace="pre-wrap">{message}</ZText>

      <ZBottomContainer>
        <ZButton loading={loading} onClick={() => onDecision(true)}>
          Continue
        </ZButton>

        <ZButton disabled={loading} onClick={() => setConfirmingExit(true)}>
          I wish to leave this investment journey
        </ZButton>
      </ZBottomContainer>
    </ZScreenContainer>
  )
}

export default ConfirmationOfAcceptance
